"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderDialog_unstable", {
    enumerable: true,
    get: function() {
        return renderDialog_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reacttransitiongroup = require("react-transition-group");
const _contexts = require("../../contexts");
const _dialogTransitionContext = require("../../contexts/dialogTransitionContext");
const renderDialog_unstable = (state, contextValues)=>{
    const { content, trigger } = state;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_contexts.DialogProvider, {
        value: contextValues.dialog,
        children: /*#__PURE__*/ (0, _jsxruntime.jsxs)(_contexts.DialogSurfaceProvider, {
            value: contextValues.dialogSurface,
            children: [
                trigger,
                process.env.NODE_ENV === 'test' ? state.open && /*#__PURE__*/ (0, _jsxruntime.jsx)(_dialogTransitionContext.DialogTransitionProvider, {
                    value: undefined,
                    children: content
                }) : /*#__PURE__*/ (0, _jsxruntime.jsx)(_reacttransitiongroup.Transition, {
                    mountOnEnter: true,
                    unmountOnExit: true,
                    in: state.open,
                    nodeRef: state.dialogRef,
                    // FIXME: this should not be hardcoded tokens.durationGentle
                    timeout: 250,
                    children: (status)=>/*#__PURE__*/ (0, _jsxruntime.jsx)(_dialogTransitionContext.DialogTransitionProvider, {
                            value: status,
                            children: content
                        })
                })
            ]
        })
    });
};
